const style = {
  container: {
    height: '100%',
  },
};

export default style;
